import { render, staticRenderFns } from "./SmsUserModal.vue?vue&type=template&id=36a7d96f&scoped=true&"
import script from "./SmsUserModal.vue?vue&type=script&lang=js&"
export * from "./SmsUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7d96f",
  null
  
)

export default component.exports